import React from 'react';
import { PictoProps } from './index';

export const Star = (props: PictoProps) => (
  <svg
    width={props.width || '23'}
    height={props.height || '22'}
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8887 1.10583L14.9787 7.36584L21.8887 8.37583L16.8887 13.2458L18.0687 20.1258L11.8887 16.8758L5.70867 20.1258L6.88867 13.2458L1.88867 8.37583L8.79867 7.36584L11.8887 1.10583V1.10583Z"
      stroke={props.fill || '#004653'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
